/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Status type of the device lifecycle.
 */
export enum DeviceLifecycleStatusType {
  DeviceLifecycleStatusUnknown = 'Unknown',
  DeviceLifecycleStatusEnrolled = 'Enrolled',
  DeviceLifecycleStatusDecommissioning = 'Decommissioning',
  DeviceLifecycleStatusDecommissioned = 'Decommissioned',
}
